module.exports = __webpack_public_path__ + "static/media/07_avatar_animal.edbbe6a0.png";